// extracted by mini-css-extract-plugin
export default {"LeadRecord":"LeadRecord-module-af76047fa173fcb469eb","layout":"LeadRecord-module-e92b873e1470562fbd0a"};